


























import {defineComponent, PropType} from '@vue/composition-api';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import {useVModel} from '@vueuse/core';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import TaskState from '@/task-states/models/TaskState';

export default defineComponent({
  name: 'SingleCalculationUiComponent',
  components: {StembleLatex, CalculationInput},
  props: {
    answer: {
      type: String as PropType<string | null>,
    },
    allowEditing: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    prependText: {
      type: String as PropType<string>,
      default: null,
    },
    appendText: {
      type: String as PropType<string>,
      default: null,
    },
    taskState: {
      type: Object as PropType<TaskState | null>,
      default: null,
    },
    question: {
      type: String as PropType<string>,
      default: null,
    },
  },
  emits: {
    'update:answer': (answer: string) => null,
  },
  setup(props) {
    const answerModel = useVModel(props, 'answer');
    const inputId = Math.random().toString(36).substring(7);

    return {answerModel, inputId};
  },
});
